var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.title,
        visible: _vm.dialogFormVisible,
        width: "500px"
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogFormVisible = $event
        },
        close: _vm.close
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function() {
            return [
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取 消")]),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.save } },
                [_vm._v("确 定")]
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { "label-width": "80px", model: _vm.form, rules: _vm.rules }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "用户名", prop: "username" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.username,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "username",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.username"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "密码", prop: "password" } },
            [
              _c("el-input", {
                attrs: { type: "password" },
                model: {
                  value: _vm.form.password,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "password",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.password"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "邮箱", prop: "email" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.form.email,
                  callback: function($$v) {
                    _vm.$set(
                      _vm.form,
                      "email",
                      typeof $$v === "string" ? $$v.trim() : $$v
                    )
                  },
                  expression: "form.email"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "角色", prop: "roles" } },
            [
              _c(
                "el-checkbox-group",
                {
                  model: {
                    value: _vm.form.roles,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "roles", $$v)
                    },
                    expression: "form.roles"
                  }
                },
                [
                  _c("el-checkbox", { attrs: { label: "admin" } }),
                  _c("el-checkbox", { attrs: { label: "editor" } })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }